<script setup>
definePage({
  meta: {
    layout: "default",
  },
});
const pageTitle = "Settlement Report";

const breadCrumbs = [
  {
    title: "Dashboard",
    to: "/admin/dashboard",
  },
  {
    title: "Report",
    to: null,
  },
  {
    title: pageTitle,
    to: "/admin/settlement-report",
  },
  {
    title: "09/11/2023-09/12/2023",
    to: null,
  },
];
</script>

<template>
  <VBreadcrumbs :items="breadCrumbs" class="px-0 pt-0 pb-5" />
  <VForm ref="refForm" @submit.prevent="() => {}">
    <VRow class="d-flex align-center flex-wrap justify-space-between">
      <VCol cols="6">
        <div class="my-4">
          <h4 class="text-h4">{{ pageTitle }}</h4>
        </div>
      </VCol>
      <VCol class="" cols="6">
        <div class="d-flex gap-4 align-end float-end">
          <VBtn color="primary" type="button" variant="tonal"> PDF</VBtn>
          <VBtn> Manual Settlement</VBtn>
        </div>
      </VCol>
    </VRow>
  </VForm>
  <VCard border class="v-card-data" title="Settlement Information">
    <VTable class="text-no-wrap" density="compact">
      <tbody>
        <tr>
          <td>Merchant name</td>
          <td>SampleAP</td>
        </tr>
        <tr>
          <td>Settlement start day</td>
          <td>23/02/2023</td>
        </tr>
        <tr>
          <td>Settlement end day</td>
          <td>23/02/2023</td>
        </tr>
        <tr>
          <td>Settlement date</td>
          <td>24/02/2023</td>
        </tr>
        <tr>
          <td>Transfer date</td>
          <td>-</td>
        </tr>
        <tr>
          <td>Deal amount</td>
          <td>-1,000,000</td>
        </tr>
        <tr>
          <td>Deal count</td>
          <td>-2</td>
        </tr>
        <tr>
          <td>Tax PB1 rate</td>
          <td>10.0 %</td>
        </tr>
        <tr>
          <td>Tax PB1</td>
          <td>-90,909</td>
        </tr>
        <tr>
          <td>Amount excl. Tax</td>
          <td>-909,091</td>
        </tr>
      </tbody>
    </VTable>
    <VDivider />
    <VCardTitle>Transfer Information</VCardTitle>
    <VTable class="text-no-wrap" density="compact">
      <tbody>
        <tr>
          <td>Transfer type</td>
          <td>Bank</td>
        </tr>
        <tr>
          <td>Transfer bank code</td>
          <td>0000</td>
        </tr>
        <tr>
          <td>Transfer bank name</td>
          <td>No Bank</td>
        </tr>
        <tr>
          <td>Transfer bank branch code</td>
          <td>000000</td>
        </tr>
        <tr>
          <td>Transfer bank account</td>
          <td>00000000</td>
        </tr>
        <tr>
          <td>Transfer credit account</td>
          <td>-</td>
        </tr>
      </tbody>
    </VTable>
  </VCard>
  <div class="mx-auto text-center">
    <VBtn
      :to="{ path: '/admin/settlement-report' }"
      class="mt-5 mx-auto text-center"
      color="secondary"
    >
      <VIcon icon="tabler-refresh" start />
      Back to {{ pageTitle }}
    </VBtn>
  </div>
</template>
